import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DiagnosticCircleGlyph = /*#__PURE__*/createElement("g", {
  id: "diagnostic_circle",
  style: {
    transform: 'translate(4px, 0) scale(2.8, 2.8)'
  },
  fill: "none"
}, /*#__PURE__*/createElement("path", {
  d: "M1.22619 10.7262H7.58159L8.48635 8.91667L11.4268 15.6748L14.5935 7.36092L16.1768 10.7262H19.7738M20 10.5C20 15.7467 15.7467 20 10.5 20C5.2533 20 1 15.7467 1 10.5C1 5.25329 5.2533 1 10.5 1C15.7467 1 20 5.25329 20 10.5Z"
}));
const DiagnosticCircle = createSvg({
  name: 'diagnostic_circle',
  path: DiagnosticCircleGlyph
});

export default DiagnosticCircle;
export { DiagnosticCircleGlyph };
